import React from 'react';
import { SerializedStyles } from '@emotion/react';
import { SearchAutocomplete } from '../..';

interface LandingPageBannerStyles {
  bannerContainer: (desktop: string, mobile: string) => SerializedStyles;
  landing: SerializedStyles;
  wrapper: SerializedStyles;
  content: SerializedStyles;
  title: SerializedStyles;
  subtitle: SerializedStyles;
  search: SerializedStyles;
}

interface LandingPageBannerProps {
  bannerImage: string;
  skipLinkContentId: string;
  styles: LandingPageBannerStyles;
}

const LandingPageBanner = ({
  bannerImage,
  skipLinkContentId,
  styles,
}: LandingPageBannerProps): JSX.Element => (
  <div css={styles.bannerContainer(bannerImage, bannerImage)}>
    <div css={styles.landing}>
      <div css={styles.wrapper}>
        <div css={styles.content} id={skipLinkContentId}>
          <h1 css={styles.title}>
            <span>Find your local</span>
            <span> Real Estate Agent</span>
          </h1>
          <p css={styles.subtitle}>Choose from over 45,000 nationwide</p>
          <div css={styles.search}>
            <SearchAutocomplete recentSearches icons isLocationSearchByAgent />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default LandingPageBanner;
